import {
  Component,
  OnInit,
  Input,
  Inject,
  Output,
  EventEmitter,
} from "@angular/core";
import * as moment from "moment";
import { AuthService } from "../core/auth/auth.service";
import { AppConfig } from "src/config/app.config";
import { SortEvent, SortDirection } from "@allianz/ng-aquila/table";
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import { PolicyStatus } from "../core/policyStatus.model";

@Component({
  selector: "app-policy-sale-report",
  templateUrl: "./policy-sale-report.component.html",
  styleUrls: ["./policy-sale-report.component.css"],
  standalone: false
})
export class PolicySaleReportComponent {
  @Input() policyStartDate: moment.Moment;
  @Input() policyEndDate: moment.Moment;

  fileName: string;
  ReportData: any;
  exportdata: any = [];
  _apiUrl: string;
  clientId: number;
  userTypeId: number;
  userBaseTypeId: number;
  userId: number;
  policyStatus: any;

  /** sorting starts here */

  sortTable(sort: SortEvent) {
    this.ReportData = this.ReportData.sort((a, b) => {
      if (sort.active in a && sort.active in b) {
        return this.compare(a[sort.active], b[sort.active], sort.direction);
      }
      return 0;
    });
  }

  compare(
    a: number | string | Date,
    b: number | string | Date,
    direction: SortDirection
  ) {
    return (a < b ? -1 : 1) * (direction === "asc" ? 1 : -1);
  }
  /** sorting ends here */
  /**Pagination Start */
  count: number = 0;
  pageNumber: number = 1;
  pageSize: number = 10;
  searchTerm: any = "";
  prevPage() {
    this.pageNumber--;
    this.getReportData();
  }

  nextPage() {
    this.pageNumber++;
    this.getReportData();
  }

  goToPage(n: number) {
    this.pageNumber = n;
    this.getReportData();
  }
  /**Pagination end */

  constructor(private authService: AuthService, private appConfig: AppConfig) {
    this._apiUrl = appConfig.baseUrl;
    this.clientId = parseInt(atob(localStorage.getItem("CLIENT_ID")));
    this.userBaseTypeId = parseInt(
      atob(localStorage.getItem("USER_BASE_TYPE_ID"))
    );
    this.userTypeId = parseInt(atob(localStorage.getItem("USER_TYPE_ID")));
    this.policyStatus = PolicyStatus;
  }

  loadReport() {
    this.pageNumber = 1;
    this.getReportData();
  }

  getReportData() {
    var startdate =
      this.policyStartDate == undefined
        ? ""
        : this.policyStartDate.format("LL");
    var enddate =
      this.policyEndDate == undefined ? "" : this.policyEndDate.format("LL");
    this.authService
      .getList(
        this._apiUrl +
        "/api/v1/PolicyDetails" +
        "?pageNumber=" +
        this.pageNumber +
        "&pageSize=" +
        this.pageSize +
        "&searchText=" +
        this.searchTerm +
        "&startDatepicker=" +
        startdate +
        "&endDatepicker=" +
        enddate
      )
      .subscribe(
        (response) => {
          if (response) {
            this.ReportData = response.body;
            var pagingProp = JSON.parse(response.headers.get("X-Pagination"));
            this.count = pagingProp.TotalCount;
          }
        },
        (error) => {

        }
      );
  }

  exporttoexcel() {
    this.pageNumber = -1;
    this.getExportData();
  }

  getExportData() {
    var startdate =
      this.policyStartDate == undefined
        ? ""
        : this.policyStartDate.format("LL");
    var enddate =
      this.policyEndDate == undefined ? "" : this.policyEndDate.format("LL");
    this.authService
      .getList(
        this._apiUrl +
        "/api/v1/PolicyDetails" +
        "?pageNumber=" +
        this.pageNumber +
        "&pageSize=" +
        this.pageSize +
        "&searchText=" +
        this.searchTerm +
        "&startDatepicker=" +
        startdate +
        "&endDatepicker=" +
        enddate
      )
      .subscribe(
        (response) => {
          if (response) {
            this.exportdata = [];
            response.body.forEach((element) => this.setExportData(element));
            this.bindexcel();
          }
        },
        (error) => {

        }
      );
  }

  setExportData(item: any) {
    const data: any = {
      policyNo: item.policyNo,
      vinChassisNo: item.vinChassisNo,
      customerFirstName: item.customerFirstName,
      invoiceDate: new Date(item.invoiceDate).toLocaleDateString(),
      effectiveDate: new Date(item.effectiveDate).toLocaleDateString(),
      price: item.price,
      policyStatus: '',
      sellingAdvisor: item.soldBy,
    };

    switch (item.policyStatusId) {
      case PolicyStatus.Active:
        data.policyStatus = "Active";
        break;
      case PolicyStatus.Cancel:
        data.policyStatus = "Cancel";
        break;
      case PolicyStatus.Modified:
        data.policyStatus = "Modified";
        break;
      case PolicyStatus.CancelationApprovalPending:
        data.policyStatus = "Cancelation Approval Pending";
        break;
      case PolicyStatus.ModificationApprovalPending:
        data.policyStatus = "Modification Approval Pending";
        break;
    }

    this.exportdata.push(data);
  }


  bindexcel() {
    /* json data is passed over here */
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Policy_Sale_Report');

    // Define the columns
    worksheet.columns = [
      { header: 'Policy No', key: 'policyNo', width: 20 },
      { header: 'VIN/Chassis No', key: 'vinChassisNo', width: 25 },
      { header: 'Customer First Name', key: 'customerFirstName', width: 25 },
      { header: 'Invoice Date', key: 'invoiceDate', width: 15 },
      { header: 'Effective Date', key: 'effectiveDate', width: 15 },
      { header: 'Price', key: 'price', width: 12 },
      { header: 'Policy Status', key: 'policyStatus', width: 25 },
      { header: 'Selling Advisor', key: 'sellingAdvisor', width: 20 },
    ];

    // Add data rows
    this.exportdata.forEach(item => {
      worksheet.addRow(item);
    });

    /* save to file */
    this.fileName =
      "PolicySaleReport_" +
      new Date(Date.now()).toLocaleString().split(",")[0] +
      ".xlsx";
    this.saveAsExcelFile(workbook, this.fileName);
  }

  saveAsExcelFile(wb: any, fileName: string): void {
    wb.xlsx.writeBuffer().then((data) => {
      var blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var a = window.document.createElement('a');
      var downloadUrl = window.URL.createObjectURL(blob);
      a.href = downloadUrl;
      a.download = `${fileName}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);
    });
  }
}
